import { useState, useEffect, useRef } from 'react';
import { getEmployeeNote, saveEmployeeNote, listEmployeeDocs, addEmployeeDoc, docUrl, removeEmployeeDoc } from '../lib/employeeDetails';

const KINDS = ['Contrato', 'DNI', 'Certificado', 'Otro'];

export function EmployeeNotes({ emp, canEdit, adminId, showToast }) {
  const [v, setV] = useState(null); const [orig, setOrig] = useState(''); const [busy, setBusy] = useState(false);
  useEffect(() => { getEmployeeNote(emp.id).then((x) => { setV(x.note || ''); setOrig(x.note || ''); }).catch(() => setV('')); }, [emp.id]);
  if (v === null) return <p className="text-sm text-gray-400 text-center py-10">Cargando…</p>;
  const save = async () => { setBusy(true); try { await saveEmployeeNote(emp.id, v, adminId); setOrig(v); showToast?.('Nota guardada'); } catch (e) { showToast?.(e.message, 'error'); } setBusy(false); };
  return (
    <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">
      <div className="rounded-2xl border border-gray-100 p-3.5">
        <p className="text-[11px] font-bold uppercase tracking-wide text-gray-400">Notas privadas</p>
        <p className="text-xs text-gray-400 mt-0.5 mb-2">Solo las ven los administradores con acceso a Empleados. {emp.name.split(' ')[0]} no las ve.</p>
        <textarea value={v} onChange={(e) => setV(e.target.value)} readOnly={!canEdit} rows={8} placeholder="Observaciones, acuerdos, seguimiento…"
          className="w-full px-3 py-2 rounded-xl border border-gray-200 text-sm text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200" />
        {canEdit && v !== orig && <button type="button" onClick={save} disabled={busy} className="mt-2 w-full text-sm font-semibold text-white bg-sky-600 py-2.5 rounded-xl disabled:opacity-50">{busy ? 'Guardando…' : 'Guardar nota'}</button>}
      </div>
    </div>
  );
}

export function EmployeeDocs({ emp, canEdit, adminId, orgId, showToast }) {
  const [docs, setDocs] = useState(null); const [kind, setKind] = useState('Contrato'); const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const load = () => listEmployeeDocs(emp.id).then(setDocs).catch(() => setDocs([]));
  useEffect(() => { load(); }, [emp.id]); // eslint-disable-line
  const onFile = async (e) => {
    const f = e.target.files?.[0]; e.target.value = ''; if (!f) return;
    setBusy(true);
    try { await addEmployeeDoc(orgId, emp.id, f, kind, adminId); await load(); showToast?.('Documento subido'); } catch (er) { showToast?.(er.message, 'error'); }
    setBusy(false);
  };
  const open = async (d) => { try { window.open(await docUrl(d.path), '_blank', 'noopener'); } catch (e) { showToast?.(e.message, 'error'); } };
  const del = async (d) => { if (!window.confirm('¿Eliminar "' + d.name + '"?')) return; try { await removeEmployeeDoc(d); await load(); } catch (e) { showToast?.(e.message, 'error'); } };
  return (
    <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">
      {canEdit && (
        <div className="rounded-2xl border border-gray-100 p-3.5 flex items-center gap-2">
          <select value={kind} onChange={(e) => setKind(e.target.value)} className="flex-1 min-w-0 px-3 py-2 rounded-xl border border-gray-200 text-[13px] bg-white text-gray-600">{KINDS.map((k) => <option key={k}>{k}</option>)}</select>
          <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="px-3.5 py-2 rounded-xl text-[13px] font-semibold text-white bg-sky-600 disabled:opacity-50">{busy ? 'Subiendo…' : 'Subir archivo'}</button>
          <input ref={ref} type="file" className="hidden" onChange={onFile} />
        </div>
      )}
      <div className="rounded-2xl border border-gray-100 p-3.5">
        <p className="text-[11px] font-bold uppercase tracking-wide text-gray-400 mb-1">Documentos</p>
        {docs === null ? <p className="text-sm text-gray-400 py-3">Cargando…</p> : docs.length === 0 ? <p className="text-sm text-gray-400 py-3">Todavía no hay documentos.</p> : (
          <div className="divide-y divide-gray-50">
            {docs.map((d) => (
              <div key={d.id} className="flex items-center justify-between gap-2 py-2">
                <button type="button" onClick={() => open(d)} className="text-left min-w-0">
                  <p className="text-sm text-gray-800 truncate">{d.name}</p>
                  <p className="text-[11px] text-gray-400">{d.kind || 'Documento'} · {new Date(d.created_at).toLocaleDateString('es-AR')}</p>
                </button>
                {canEdit && <button type="button" onClick={() => del(d)} className="text-xs font-semibold text-red-500 shrink-0">Eliminar</button>}
              </div>
            ))}
          </div>
        )}
        <p className="text-[11px] text-gray-400 mt-2">Archivos privados (hasta 10 MB). El enlace para abrirlos dura 5 minutos.</p>
      </div>
    </div>
  );
}
